import { createSlice } from '@reduxjs/toolkit'
import { SegmentListType } from 'features/Programs/Shared/types'
import { ReportType, HeaderCell, TableDataType } from './types'
import { YearMonth } from 'core-system/MonthRangePicker/DropdownCalendar'
import columnNames from './columnNames.json'
import wordings from './wordings.json'

export interface ReportsState {
  selectedSegments: SegmentListType[]
  reportType: ReportType
  startDate: YearMonth
  endDate: YearMonth
  tableData: TableDataType[][]
  tableMessage: string
  isTableLoading: boolean
  headerCells: HeaderCell[]
  isFileDownloading: boolean
  isAiReportLoading: boolean
  aiReportError: string | null
  aiReportSuccess: boolean
}

const INITIAL_STATE: ReportsState = {
  selectedSegments: [],
  reportType: 'usage',
  startDate: null,
  endDate: null,
  tableData: [],
  tableMessage: wordings.defaultReportMessage,
  isTableLoading: false,
  headerCells: columnNames['usage'],
  isFileDownloading: false,
  isAiReportLoading: false,
  aiReportError: null,
  aiReportSuccess: false,
}

const reportsSlice = createSlice({
  name: 'reports',
  initialState: INITIAL_STATE,
  reducers: {
    setSelectedSegments: (state, action) => {
      state.selectedSegments = action.payload
    },
    setReportType: (state, action) => {
      state.reportType = action.payload
    },
    setStartDate: (state, action) => {
      state.startDate = action.payload
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload
    },
    setTableData: (state, action) => {
      state.tableData = action.payload
    },
    setTableMessage: (state, action) => {
      state.tableMessage = action.payload
    },
    setTableLoading: (state, action) => {
      state.isTableLoading = action.payload
    },
    clearTableData: (state) => {
      state.tableData = []
    },
    setHeaderCells: (state, action) => {
      state.headerCells = action.payload
    },
    setIsFileDownloading: (state, action) => {
      state.isFileDownloading = action.payload
    },
    setAiReportLoading: (state, action) => {
      state.isAiReportLoading = action.payload
      if (action.payload) {
        state.aiReportError = null
        state.aiReportSuccess = false
      }
    },
    setAiReportError: (state, action) => {
      state.aiReportError = action.payload
      state.isAiReportLoading = false
      state.aiReportSuccess = false
    },
    setAiReportSuccess: (state) => {
      state.isAiReportLoading = false
      state.aiReportError = null
      state.aiReportSuccess = true
    },
    resetAiReportStatus: (state) => {
      state.aiReportError = null
      state.aiReportSuccess = false
    },
  },
})

export const reportsReducer = reportsSlice.reducer
export const reportsReducers = {
  ...reportsSlice.actions,
}
